import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useClickAnalytics} from '@github-ui/use-analytics'
import {ThreeBarsIcon} from '@primer/octicons-react'
import {IconButton} from '@primer/react'
import {clsx} from 'clsx'

import navItemStyles from '../primitives/styles.module.css'
import {analyticsCategory} from './constants'
import styles from './GlobalNavMenuToggle.module.css'

function PancakeIcon({className}: {className?: string}) {
  return (
    <span className={clsx(styles.pancakeIcon, className)} aria-hidden="true">
      🥞
    </span>
  )
}

export function GlobalNavMenuToggle({
  ref,
  setOpen,
  open,
  isLoading = false,
}: {
  setOpen: (open: boolean) => void
  open: boolean
  isLoading?: boolean
  ref?: React.Ref<HTMLButtonElement>
}) {
  const {sendClickAnalyticsEvent} = useClickAnalytics()

  return (
    <IconButton
      ref={ref}
      variant="invisible"
      className={navItemStyles.appHeaderButton}
      aria-haspopup="dialog"
      onClick={() => {
        setOpen(!open)
        sendClickAnalyticsEvent({category: analyticsCategory, action: 'GLOBAL_NAV_MENU_TOGGLE'})
      }}
      aria-label="Open menu"
      loading={isLoading && open}
      icon={isFeatureEnabled('pull_request_stacks_pancake_icon') ? PancakeIcon : ThreeBarsIcon}
    />
  )
}
